/**
 * NumberInput — question type 'number' (catalog 3.7; Dr. Rami 2026-10-11: usual weight as a number, so the
 * panel can show % body weight lost against the profile's current weight). Saved as ONE English answer, the way
 * pack-years is: "165 lb", or "Not sure" when the question allows it.
 */
const NOT_SURE = 'Not sure'

export function parseNumberAnswer(value) {
  const m = typeof value === 'string' && value.match(/^(\d+(?:\.\d+)?)\b/)
  return m ? Number(m[1]) : null
}

export default function NumberInput({ question, value, onChange, disabled, to }) {
  const unit = question.unit || ''
  const notSure = value === NOT_SURE
  const n = parseNumberAnswer(value)
  const setNumber = (raw) => {
    if (disabled) return
    const digits = String(raw).replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6)
    onChange(digits ? `${digits}${unit ? ` ${unit}` : ''}` : '')
  }
  return (
    <div className="space-y-2">
      <div className={`flex items-center h-[46px] rounded-xl border border-gray-200 px-3 ${notSure ? 'opacity-40' : ''}`}>
        <input
          type="text"
          inputMode="decimal"
          aria-label={question.text}
          disabled={disabled || notSure}
          value={n ?? ''}
          onChange={(e) => setNumber(e.target.value)}
          className="flex-1 bg-transparent text-base font-semibold tabular-nums text-[#15354F] outline-none"
        />
        {unit && <span className="text-sm text-gray-500 ml-2">{unit}</span>}
      </div>
      {question.allowUnknown && (
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange(notSure ? '' : NOT_SURE)}
          className={`w-full p-3 rounded-xl border text-left flex items-center gap-3 transition-all ${notSure ? 'border-orella-500 bg-orella-50' : 'border-gray-200'}`}
        >
          <span className={`w-5 h-5 rounded-full border-2 flex-shrink-0 ${notSure ? 'border-orella-500 shadow-[inset_0_0_0_4px_#46A8F9]' : 'border-gray-300'}`} />
          <span className="text-sm text-gray-700">{to(NOT_SURE)}</span>
        </button>
      )}
    </div>
  )
}
